import { useTranslation } from 'react-i18next';
import type { StudyStatus } from '@/api/generated/types.gen';
import { cn } from '@/lib/utils';
import { statusTone, toneBadgeClass } from '@/lib/statusTone';
import { STUDY_STATUS_LABEL_KEYS } from '@/lib/statusLabels';

interface StudyStatusBadgeProps {
  status: StudyStatus;
}

export default function StudyStatusBadge({ status }: StudyStatusBadgeProps) {
  const { t } = useTranslation();
  const labelKey = STUDY_STATUS_LABEL_KEYS[status];
  const label = labelKey ? t(labelKey) : status;
  return (
    <span
      // ENG-1744: the four amber statuses here were `text-warning` on a
      // `/10` tint — 1.79:1 against AA's 4.5. The warning tone carries
      // `text-warning-strong`, which measures 4.96 on that same tint.
      title={label}
      className={cn(
        // w-max max-w-full: natural chip width until the Status cell squeezes,
        // then ellipsize inside the pill (same ENG-3124 density fix as MeshGen).
        'inline-flex w-max max-w-full min-w-0 items-center overflow-hidden rounded-full px-2 py-0.5 text-xs font-semibold',
        toneBadgeClass(statusTone('study', status)),
      )}
    >
      <span className="truncate">{label}</span>
    </span>
  );
}
